import { DatePipe, DOCUMENT } from '@angular/common';
import { Component, OnInit, Input, ViewChild, ElementRef, Directive, OnDestroy, HostListener, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { max } from 'rxjs/operators';
import { ApiService } from 'src/app/core/helpers/apiClient';
//import Swal from 'sweetalert2';
import appSettings from '../../../assets/settings/system.settings.json'
import { ConfigService } from "src/app/core/services/getSettings";
import { ChartType } from './chart-model/apex.model';
import { TreeviewItem, TreeviewConfig } from 'ngx-treeview';
import * as c3 from 'c3';
import {
  ApexAxisChartSeries, ApexChart, ChartComponent, ApexDataLabels, ApexPlotOptions, ApexResponsive, ApexXAxis, ApexLegend, ApexFill
} from "ng-apexcharts";


export type ChartOptions = {

  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  responsive: ApexResponsive[];
  xaxis: ApexXAxis;
  legend: ApexLegend;
  fill: ApexFill;
};


@Component({
  selector: 'dashboard-shared',
  templateUrl: './dashboard-shared.component.html',
  styleUrls: ['./dashboard-shared.component.scss'],
  providers: [DatePipe]
})
export class DashboardSharedComponent implements OnDestroy {
  protected appSettings = ConfigService.settings;

  //#region SystemSettings
  apiPath = `${this.appSettings.apiPath.crop}/api/dashboard`;

  //timer
  timerValue;

  //Drop Down
  regionList: any[];
  businessUnitList: any[];
  operatingUnitList: TreeviewItem[] = [];
  dateList = [
    { "index": 1, "dateV": "1 to 7", "from": 1, "to": 7 },
    { "index": 2, "dateV": "8 to 15", "from": 8, "to": 15 },
    { "index": 3, "dateV": "16 to 23", "from": 16, "to": 23 },
    { "index": 4, "dateV": "24 to 31", "from": 24, "to": 31 }];
  chartDateSel = 0;
  chartDetailsCollapsed: boolean = true;
  estateProductivityRainFallchartDetailsCollapsed: boolean = true;
  estateHarversterchartDetailsCollapsed: boolean = true;
  cropActualvsBudgetchartDetailsCollapsed: boolean = true;
  //Chart Table
  totalRecords: number;
  startIndex: number;
  endIndex: number;
  page: number = 1;
  pageSize: number = 10;
  chartDetailsData;
  currentDate;
  chardDetailsDataList;
  showChartDetailsDetails: boolean[] = [];
  SubChartLabel;
  estateProductivityRainFallChartData;
  cropChartData;
  estateHarversterChartData;

  //Chart
  linewithDataChart;
  showLineChart: boolean = false;
  chartData: any[];
  screenWidth;
  chartTitle;
  cartSelLabel;
  chartLabelColor;

  //CurrentDate
  newcurrentDate;
  yesterdayDate;
  


  //Unit
  regionSelVal;
  businessSelVal;
  operatingSelVal = [];
  showSingle: boolean = false;
  operatingSelSingleVal;
  operatingSelSingleValName;
  estateMillList: any[] = [];
  chartOuHeader: any[] = [];

  //Pie Chart
  estateProducitivtyPieChartData;
  estateProductivityPieChartDetailsCollapsed: boolean=true;


  //Text
  yphText = "Yield Per Hectare Month Todate";
  mtdText = "Month Todate";
  ytdText = "Year Todate";
  yphmonthText = "Yield Per Hectare Todate ( Month )";
  yphyearText = "Yield Per Hectare Todate ( Year )";


  yphTexth = "Yield Per Hectare This Month";
  mtdTexth = "Month History Crop";
  ytdTexth = "Year History Crop";

  yphTextCompare1 = "Yield Per Hectare";
  mtdTextCompare1 = "Month Todate Crop";
  ytdTextCompare1 = "Year Todate Crop";
  matureAreaTextCompare1 = 'Mature Area'

  yphTextCompare2 = "Yield Per Hectare";
  mtdTextCompare2 = "Month Todate Crop";
  ytdTextCompare2 = "Year Todate Crop";
  matureAreaTextCompare2 = 'Mature Area'


  groupingType = 'day';

  //Date
  selDate = this.getYesterday();

  //Month
  selMonth = Number(this.datePipe.transform(new Date(), 'MM'));
  months: any[] = this.monthList(this.selMonth);
  
;

  //Year
  years: number[] = [];
  selYear = Number(this.datePipe.transform(new Date(), 'yyyy'));

  //Range
  selMonthFrom = Number(this.datePipe.transform(new Date(), 'MM'));
  selMonthTo = Number(this.datePipe.transform(new Date(), 'MM'));
  monthsFrom: any[] = this.monthList(this.selMonthFrom);
  monthsTo: any[] = this.monthList(this.selMonthFrom, this.selMonthTo);


  //Compare
  compareData = false;
  compareDate1ValChange = false;
  compareDate2ValChange = false;
  compareDate1 = this.getYesterday();
  compareDate2 = this.getYesterday();

  compareYearSel1 = Number(this.datePipe.transform(new Date(), 'yyyy'));
  compareMonthSel1 = Number(this.datePipe.transform(new Date(), 'MM'));
  compareMonthFromSel1 = Number(this.datePipe.transform(new Date(), 'MM'));
  compareMonthToSel1 = Number(this.datePipe.transform(new Date(), 'MM'));
  compareMonthsFrom1: any[] = this.monthList(this.compareMonthFromSel1);
  compareMonthsTo1: any[] = this.monthList(this.compareMonthFromSel1, this.compareMonthFromSel1);
  compareMonths1: any[] = this.monthList(this.compareMonthSel1);

  compareYearSel2 = Number(this.datePipe.transform(new Date(), 'yyyy'));
  compareMonthSel2 = Number(this.datePipe.transform(new Date(), 'MM'));
  compareMonthFromSel2 = Number(this.datePipe.transform(new Date(), 'MM'));
  compareMonthToSel2 = Number(this.datePipe.transform(new Date(), 'MM'));
  compareMonthsFrom2: any[] = this.monthList(this.compareMonthFromSel2);
  compareMonthsTo2: any[] = this.monthList(this.compareMonthFromSel2, this.compareMonthFromSel2);
  compareMonths2: any[] = this.monthList(this.compareMonthSel2);

  //Quater
  QuaterList: any[];
  selectedQuarter;
  compareQuarter1;
  compareQuarter2;

  //Val
  //Daily
  dailyMt: number = 0;
  dailyBudget: number = 0;
  dailyVarPer: number = 0;
  dailyVarMt: number = 0;
  //Monthly
  monthlyMt: number = 0;
  monthlyBudget: number = 0;
  monthlyVarPer: number = 0;
  monthlyVarMt: number = 0;
  //Yearly
  yearlyMt: number = 0;
  yearlyBudget: number = 0;
  yearlyVarPer: number = 0;
  yearlyVarMt: number = 0;
  //YPH
  yphMt: number = 0;
  yphBudget: number = 0;
  yphVarPer: number = 0;
  yphVarMt: number = 0;
  //HA
  haMt: number = 0;
  haBudget: number = 0;
  haVarMt: number = 0;
  haVarPer: number = 0;


  //yphdayMDT
  yphMDT: number = 0;
  yphMDTBudget: number = 0;
  yphMDTVarPer: number = 0;
  yphMDTVarMt: number = 0;
  //yphmonthMDT
  yphMDTMonth: number = 0;
  yphMDTMonthBudget: number = 0;
  yphMDTMonthVarPer: number = 0;
  yphMDTMonthVarMt: number = 0;
  //yphyearMDT
  yphMDTYear: number = 0;
  yphMDTYearBudget: number = 0;
  yphMDTYearVarPer: number = 0;
  yphMDTYearVarMt: number = 0;

  //Compare1
  //Daily
  daily1Mt: number = 0;
  daily1Budget: number = 0;
  daily1VarPer: number = 0;
  daily1VarMt: number = 0;
  //Monthly
  monthly1Mt: number = 0;
  monthly1Budget: number = 0;
  monthly1VarPer: number = 0;
  monthly1VarMt: number = 0;
  //Yearly
  yearly1Mt: number = 0;
  yearly1Budget: number = 0;
  yearly1VarPer: number = 0;
  yearly1VarMt: number = 0;
  //YPH
  yph1Mt: number = 0;
  yph1Budget: number = 0;
  yph1VarPer: number = 0;
  yph1VarMt: number = 0;
  //HA
  ha1Mt: number = 0;
  ha1Budget: number = 0;
  ha1VarMt: number = 0;
  ha1VarPer: number = 0;

  //Compare2
  //Daily
  daily2Mt: number = 0;
  daily2Budget: number = 0;
  daily2VarPer: number = 0;
  daily2VarMt: number = 0;
  //Monthly
  monthly2Mt: number = 0;
  monthly2Budget: number = 0;
  monthly2VarPer: number = 0;
  monthly2VarMt: number = 0;
  //Yearly
  yearly2Mt: number = 0;
  yearly2Budget: number = 0;
  yearly2VarPer: number = 0;
  yearly2VarMt: number = 0;
  //YPH
  yph2Mt: number = 0;
  yph2Budget: number = 0;
  yph2VarPer: number = 0;
  yph2VarMt: number = 0;
  //HA
  ha2Mt: number = 0;
  ha2Budget: number = 0;
  ha2VarMt: number = 0;
  ha2VarPer: number = 0;

  config = TreeviewConfig.create({
    hasAllCheckBox: true,
    hasFilter: true,
    hasCollapseExpand: true,
    decoupleChildFromParent: false,
    maxHeight: 400
  });

  //#endregion SystemSettings

  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    private elRef: ElementRef,
    @Inject(DOCUMENT) private document: Document) {

    if (!sessionStorage.getItem("tokenInfo")) {
      this.route.queryParams.subscribe(params => {
        var token = params["token"];
        if (!token) {
          this.router.navigate(['/account/login'], { relativeTo: this.route });
        } else {
          sessionStorage.setItem('tokenInfo', token);
        }
      });
    }


    //Yesterday Date
    var todayDate = new Date();
    todayDate.setDate(todayDate.getDate()-1);
    this.newcurrentDate = todayDate;
    this.yesterdayDate = this.newcurrentDate;

    var years = new Date().getFullYear();
    for (let year = years; year >= 2000; year--) {
      this.years.push(year);
    }
    this.getDetails(true);
    this.loadQuaterDropDown();
    this.dataAutoQueryTimer();
    this.filter();
  }

  getYesterday() {
    var yesterdayDate = new Date();
    return this.datePipe.transform(yesterdayDate.setDate(yesterdayDate.getDate() - 1), 'yyyy-MM-dd');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenWidth = window.innerWidth;
    this.buildColumnChart(null);
  }


  buildChartLabelColor() {
    if (this.document.body.classList.contains("dark-theme")) {
      return "#FFFFFF";
    } else {
      return "#000000";
    }
  }

  ngOnDestroy(): void {
    if (this.timerValue) {
      clearInterval(this.timerValue);
    }
  }

  dataAutoQueryTimer() {
    this.timerValue = setInterval(() => {
      this.getDetails(false, false);
    }, 6000000);
  }

  assignMonth(controller, maxMonth: number, minStrMonth?: number) {
    this[controller] = [];
    for (var i = 0; i < 12; i++) {
      var m = monthList.filter(c => c.month == i + 1)[0];
      if (m.month <= maxMonth) {
        if (minStrMonth) {
          if (m.month >= minStrMonth) {
            this[controller].push(m);
          }
        }
        else {
          this[controller].push(m);
        }
      }
    }
  }

  monthList(maxMonth: number, minStrMonth?: number) {
    var monthS = [];
    for (var i = 0; i < 12; i++) {
      var m = monthList.filter(c => c.month == i + 1)[0];
      if (m.month <= maxMonth) {
        if (minStrMonth) {
          if (m.month >= minStrMonth) {
            monthS.push(m);
          }
        }
        else {
          monthS.push(m);
        }
      }
    }
    return monthS;
  }

  updateCardText() {
    var today = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    var todayE = new Date(today);
    var selDate;

    var month = "Month Todate";
    var year = "Year Todate";

    if (this.compareData && this.compareDate1ValChange) {
      var mtdCtr = "mtdTextCompare1";
      var ytdCtr = "ytdTextCompare1";
      var yphCtr = "yphTextCompare1";



      if (this.groupingType === "day") {
        selDate = new Date(this.compareDate1);
        var selVal = this.compareDate1ValChange ? this.compareDate1 : this.compareDate2;
        if (selVal === today) {
          this[ytdCtr] = year;
          this[mtdCtr] = month;
          this[yphCtr] = "Yield Per Hectare (Today)";
        }
        else if (selDate < todayE) {
          this[yphCtr] = "Yield Per Hectare Todate";
          this[ytdCtr] = year;
          this[mtdCtr] = month;

          if (selDate.getFullYear() === todayE.getFullYear() && selDate.getMonth() < todayE.getMonth()) {
            this[mtdCtr] = `Month Todate`;
          }
          if (selDate.getFullYear() < todayE.getFullYear()) {
            this[mtdCtr] = `Month Todate`;
            this[ytdCtr] = `Year Todate`;
          }
        }
      }
      if (this.groupingType === "month") {
        selDate = new Date(this.compareYearSel1, this.compareMonthSel1 - 1, 1);
        this[mtdCtr] = month;
        this[yphCtr] = "Yield Per Hectare Todate";
        if (selDate.getFullYear() === todayE.getFullYear() && selDate.getMonth() < todayE.getMonth()) {
          this[mtdCtr] = `Month Todate`;
          this[yphCtr] = "Yield Per Hectare This Month";
        }
        if (selDate.getFullYear() < todayE.getFullYear()) {
          this[yphCtr] = "Yield Per Hectare This Month";
          this[mtdCtr] = `Month Todate`;
        }
      }
      if (this.groupingType === "year") {
        selDate = new Date(this.compareYearSel1, 1, 1);

        this[yphCtr] = "Yield Per Hectare Todate";
        this[ytdCtr] = year;
        if (selDate.getFullYear() < todayE.getFullYear()) {
          this[yphCtr] = "Yield Per Hectare Todate";
          this[ytdCtr] = `Year Todate`;
        }
      }

      if (this.groupingType === "range") {
        selDate = new Date(this.compareYearSel1, 1, 1);
        this[yphCtr] = "Yield Per Hectare Todate";
        this[ytdCtr] = year;
        if (selDate.getFullYear() < todayE.getFullYear()) {
          this[yphCtr] = "Yield Per Hectare Todate";
          this[ytdCtr] = `Year Todate`;
        }
      }

    }

    if (this.compareData && this.compareDate2ValChange) {
      var mtdCtr = "mtdTextCompare2";
      var ytdCtr = "ytdTextCompare2";
      var yphCtr = "yphTextCompare2";



      if (this.groupingType === "day") {
        selDate = new Date(this.compareDate2);
        var selVal = this.compareDate1ValChange ? this.compareDate1 : this.compareDate2;
        if (selVal === today) {
          this[ytdCtr] = year;
          this[mtdCtr] = month;
          this[yphCtr] = "Yield Per Hectare (Today)";
        }
        else if (selDate < todayE) {
          this[yphCtr] = "Yield Per Hectare Todate";
          this[ytdCtr] = year;
          this[mtdCtr] = month;

          if (selDate.getFullYear() === todayE.getFullYear() && selDate.getMonth() < todayE.getMonth()) {
            this[mtdCtr] = `Month Todate`;
          }
          if (selDate.getFullYear() < todayE.getFullYear()) {
            this[mtdCtr] = `Month Todate`;
            this[ytdCtr] = `Year Todate`;
          }
        }
      }
      if (this.groupingType === "month") {
        selDate = new Date(this.compareYearSel2, this.compareMonthSel2 - 1, 1);
        this[mtdCtr] = month;
        this[yphCtr] = "Yield Per Hectare Todate";
        if (selDate.getFullYear() === todayE.getFullYear() && selDate.getMonth() < todayE.getMonth()) {
          this[mtdCtr] = `Month This Month`;
          this[yphCtr] = "Yield Per Hectare Todate";
        }
        if (selDate.getFullYear() < todayE.getFullYear()) {
          this[yphCtr] = "Yield Per Hectare Todate";
          this[mtdCtr] = `Month Todate`;
        }
      }
      if (this.groupingType === "year") {
        selDate = new Date(this.compareYearSel2, 1, 1);

        this[yphCtr] = "Yield Per Hectare Todate";
        this[ytdCtr] = year;
        if (selDate.getFullYear() < todayE.getFullYear()) {
          this[yphCtr] = "Yield Per Hectare Todate";
          this[ytdCtr] = `Year Todate`;
        }
      }

      if (this.groupingType === "range") {
        selDate = new Date(this.compareYearSel2, 1, 1);
        this[yphCtr] = "Yield Per Hectare Todate";
        this[ytdCtr] = year;
        if (selDate.getFullYear() < todayE.getFullYear()) {
          this[yphCtr] = "Yield Per Hectare Todate";
          this[ytdCtr] = `Year Todate`;
        }
      }

    }


    if (!this.compareData) {
      if (this.groupingType === "day") {
        selDate = new Date(this.selDate);

        if (this.selDate === today) {
          this.ytdText = year;
          this.mtdText = month;
          this.yphText = "Yield Per Hectare (Today)";
        }
        else if (selDate < todayE) {
          this.yphText = "Yield Per Hectare Todate ( Day )";
          this.ytdText = year;
          this.mtdText = month;

          if (selDate.getFullYear() === todayE.getFullYear() && selDate.getMonth() < todayE.getMonth()) {
            this.mtdText = `Month Todate`;
          }
          if (selDate.getFullYear() < todayE.getFullYear()) {
            this.mtdText = `Month Todate`;
            this.ytdText = `Year Todate`;
          }
        }
      }
      if (this.groupingType === "month") {
        selDate = new Date(this.selYear, this.selMonth - 1, 1);

        this.mtdText = month;
        this.yphText = "Yield Per Hectare Todate ( Month )";
        if (selDate.getFullYear() === todayE.getFullYear() && selDate.getMonth() < todayE.getMonth()) {
          this.mtdText = `Month This Month`;
          this.yphText = "Yield Per Hectare This Month";
        }
        if (selDate.getFullYear() < todayE.getFullYear()) {
          this.yphText = "Yield Per Hectare This Month";
          this.mtdText = `Month Todate`;
          this.ytdText = `Year Todate`;
        }
      }
      if (this.groupingType === "year") {
        selDate = new Date(this.selYear, 1, 1);
        this.yphText = "Yield Per Hectare Todate ( Year )";
        this.ytdText = year;
        if (selDate.getFullYear() < todayE.getFullYear()) {
          this.yphText = "Yield Per Hectare Todate";
          this.ytdText = `Year Todate`;
        }
      }

      if (this.groupingType === "range") {
        selDate = new Date(this.selYear, 1, 1);
        this.yphText = "Yield Per Hectare Todate";
        this.ytdText = year;
        if (selDate.getFullYear() < todayE.getFullYear()) {
          this.yphText = "Yield Per Hectare Todate";
          this.ytdText = `Year Todate`;
        }
      }
    }
  }

  async getDetails(updateUnitList: boolean = false, showSpinner: boolean = true) {
    this.updateCardText();
    
    if (showSpinner) this.spinner.show();

    if (this.showSingle && this.operatingSelVal?.length === 0) {
      this.operatingSelVal.push(this.operatingSelSingleVal);
    }
    if (this.operatingSelVal && this.operatingSelVal?.length === 0) {
      this.operatingSelVal = null;
    }
   
    var obj = {
      OperatingUnitList: this.operatingSelVal || null,
      entryDate: null,
      month: null,
      year: null,
      mthrange: null
    };


    if (this.groupingType === 'day' && !this.compareData) {
      obj.entryDate = this.selDate;
      this.newcurrentDate =this.selDate;
    } else if (this.groupingType === 'month' && !this.compareData) {

      if (!this.selYear) { this.selYear = Number(this.datePipe.transform(new Date(), "yyyy")); }
      if (!this.selMonth) { this.selMonth = Number(this.datePipe.transform(new Date(), "MM")); }
      obj.month = this.datePipe.transform(new Date(this.selYear, this.selMonth - 1, 1), "yyyy-MM-dd");

    } else if (this.groupingType === 'year' && !this.compareData) {

      if (!this.selYear) { this.selYear = Number(this.datePipe.transform(new Date(), "yyyy")); }
      if(this.selYear == new Date().getFullYear())
      {
        obj.year = this.datePipe.transform(new Date(this.selYear, this.selMonth - 1, 1), "yyyy-MM-dd");
      }
      else{
        obj.year = this.datePipe.transform(new Date(this.selYear, 0, 1), "yyyy-MM-dd");
      }
      
     

    } else if ((this.groupingType === 'range' || this.groupingType === 'quarter') && !this.compareData) {

      if (!this.selMonthFrom) { this.selMonthFrom = Number(this.datePipe.transform(new Date(), "MM")); }
      if (!this.selMonthTo) { this.selMonthTo = Number(this.datePipe.transform(new Date(), "MM")); }
      if (!this.selYear) { this.selYear = Number(this.datePipe.transform(new Date(), "yyyy")); }

      var monthFromDt = this.datePipe.transform(new Date(this.selYear, this.selMonthFrom - 1, 1), "yyyy-MM-dd");
      var monthToDt = this.datePipe.transform(new Date(this.selYear, this.selMonthTo - 1, 1), "yyyy-MM-dd");
      obj.mthrange = `${monthFromDt};${monthToDt}`;

    } else if (this.compareData) {
      obj = this.compileCompareObj(obj);
    };

    await this.apiService.post(`${this.apiPath}`, JSON.stringify(obj)).then((data: any) => {

      if (!this.compareData) {
        //Daily
        this.dailyMt = data.calculation.result.daily?.dailyCrop;
        this.dailyBudget = data.calculation.result.daily?.dailyBudget;
        this.dailyVarPer = data.calculation.result.daily?.variancePercentage;
        this.dailyVarMt = data.calculation.result.daily?.variance;

        //Monthly
        this.monthlyMt = data.calculation.result.monthly?.mtdCrop;
        this.monthlyBudget = data.calculation.result.monthly?.monthlyBudget;
        this.monthlyVarPer = data.calculation.result.monthly?.variancePercentage;
        this.monthlyVarMt = data.calculation.result.monthly?.variance;

        //Yearly
        this.yearlyMt = data.calculation.result.yearly?.ytdCrop;
        this.yearlyBudget = data.calculation.result.yearly?.yearlyBudget;
        this.yearlyVarPer = data.calculation.result.yearly?.variancePercentage;
        this.yearlyVarMt = data.calculation.result.yearly?.variance;

        //YPH
        this.yphMt = data.calculation.result.hecDaily?.yphHectare;
        this.yphBudget = data.calculation.result.hecDaily?.dailyBudget;
        this.yphVarPer = data.calculation.result.hecDaily?.variancePercentage;
        this.yphVarMt = data.calculation.result.hecDaily?.variance;

        //YPH Day
        this.yphMDT = data.calculation.result.hecDaily?.yphHectare;
        this.yphMDTBudget = data.calculation.result.hecDaily?.dailyBudget;
        this.yphMDTVarPer = data.calculation.result.hecDaily?.variancePercentage;
        this.yphMDTVarMt = data.calculation.result.hecDaily?.variance;

        //YPHMDT Month
        this.yphMDTMonth = data.calculation.result.hecMth?.yphHectare;
        this.yphMDTMonthBudget = data.calculation.result.hecMth?.dailyBudget;
        this.yphMDTMonthVarPer = data.calculation.result.hecMth?.variancePercentage;
        this.yphMDTMonthVarMt = data.calculation.result.hecMth?.variance;

        //YPHMDT Year
        this.yphMDTYear = data.calculation.result.hecYrs?.yphHectare;
        this.yphMDTYearBudget = data.calculation.result.hecYrs?.dailyBudget;
        this.yphMDTYearVarPer = data.calculation.result.hecYrs?.variancePercentage;
        this.yphMDTYearVarMt = data.calculation.result.hecYrs?.variance;

        //Range
        if (this.groupingType === 'range'|| this.groupingType === 'quarter') {
          this.yearlyMt = data.calculation.result.range?.ytdCrop;
          this.yearlyBudget = data.calculation.result.range?.yearlyBudget;
          this.yearlyVarPer = data.calculation.result.range?.variancePercentage;
          this.yearlyVarMt = data.calculation.result.range?.variance;
        }

        if(this.groupingType === 'day') {
          this.buildPieChart(data);
        }

        if (this.groupingType === 'month') {
          this.buildColumnChart(data);
          this.buildPieChart(data);
          this.buildBarLineChart(data);
          this.buildBarLineHarvesterChart(data);
          this.buildBarCropEstateChart(data);
          this.chartDetails();
        }
        if (this.groupingType === 'year') {
          this.buildColumnChart(data);
          this.buildPieChart(data);
          this.buildBarLineChart(data);
          this.buildBarLineHarvesterChart(data);
          this.buildBarCropEstateChart(data);
          this.chartDetails();
        }
        if (this.groupingType === 'range') {
          this.buildColumnChart(data);
          this.buildPieChart(data);
          this.buildBarLineChart(data);
          this.buildBarLineHarvesterChart(data);
          this.buildBarCropEstateChart(data);
          this.chartDetails();
        }

        if (this.groupingType === 'quarter') {
          this.buildColumnChart(data);
          this.buildPieChart(data);
          this.buildBarLineChart(data);
          this.buildBarLineHarvesterChart(data);
          this.buildBarCropEstateChart(data);
          this.chartDetails();
        }

        //HA
        this.haMt = data.calculation.result.mArea.matureArea;
        this.haBudget = data.calculation.result.mArea.budget;
        this.haVarMt = data.calculation.result.mArea.variance;
        this.haVarPer = data.calculation.result.mArea.variancePercentage;

      }

      if (this.compareData && this.compareDate1ValChange) {
        //Daily
        this.daily1Mt = data.calculation.result.daily?.dailyCrop;
        this.daily1Budget = data.calculation.result.daily?.dailyBudget;
        this.daily1VarPer = data.calculation.result.daily?.variancePercentage;
        this.daily1VarMt = data.calculation.result.daily?.variance;

        //Monthly
        this.monthly1Mt = data.calculation.result.monthly?.mtdCrop;
        this.monthly1Budget = data.calculation.result.monthly?.monthlyBudget;
        this.monthly1VarPer = data.calculation.result.monthly?.variancePercentage;
        this.monthly1VarMt = data.calculation.result.monthly?.variance;
        if (this.groupingType === "range"|| this.groupingType === 'quarter') {
          //Yearly
          this.yearly1Mt = data.calculation.result.range?.ytdCrop;
          this.yearly1Budget = data.calculation.result.range?.yearlyBudget;
          this.yearly1VarPer = data.calculation.result.range?.variancePercentage;
          this.yearly1VarMt = data.calculation.result.range?.variance;
        }
        else {
          //Yearly
          this.yearly1Mt = data.calculation.result.yearly?.ytdCrop;
          this.yearly1Budget = data.calculation.result.yearly?.yearlyBudget;
          this.yearly1VarPer = data.calculation.result.yearly?.variancePercentage;
          this.yearly1VarMt = data.calculation.result.yearly?.variance;
        }


        //YPH
        this.yph1Mt = data.calculation.result.hecDaily?.yphHectare;
        this.yph1Budget = data.calculation.result.hecDaily?.dailyBudget;
        this.yph1VarPer = data.calculation.result.hecDaily?.variancePercentage;
        this.yph1VarMt = data.calculation.result.hecDaily?.variance;

        this.ha1Mt = data.calculation.result.mArea.matureArea;
        this.ha1Budget = data.calculation.result.mArea.budget;
        this.ha1VarMt = data.calculation.result.mArea.variance;
        this.ha1VarPer = data.calculation.result.mArea.variancePercentage;
      }
      if (this.compareData && this.compareDate2ValChange) {
        //Daily
        this.daily2Mt = data.calculation.result.daily?.dailyCrop;
        this.daily2Budget = data.calculation.result.daily?.dailyBudget;
        this.daily2VarPer = data.calculation.result.daily?.variancePercentage;
        this.daily2VarMt = data.calculation.result.daily?.variance;

        //Monthly
        this.monthly2Mt = data.calculation.result.monthly?.mtdCrop;
        this.monthly2Budget = data.calculation.result.monthly?.monthlyBudget;
        this.monthly2VarPer = data.calculation.result.monthly?.variancePercentage;
        this.monthly2VarMt = data.calculation.result.monthly?.variance;

        if (this.groupingType === "range"|| this.groupingType === 'quarter') {
          //Yearly
          this.yearly2Mt = data.calculation.result.range?.ytdCrop;
          this.yearly2Budget = data.calculation.result.range?.yearlyBudget;
          this.yearly2VarPer = data.calculation.result.range?.variancePercentage;
          this.yearly2VarMt = data.calculation.result.range?.variance;
        }
        else {
          //Yearly
          this.yearly2Mt = data.calculation.result.yearly?.ytdCrop;
          this.yearly2Budget = data.calculation.result.yearly?.yearlyBudget;
          this.yearly2VarPer = data.calculation.result.yearly?.variancePercentage;
          this.yearly2VarMt = data.calculation.result.yearly?.variance;
        }

        //YPH
        this.yph2Mt = data.calculation.result.hecDaily?.yphHectare;
        this.yph2Budget = data.calculation.result.hecDaily?.dailyBudget;
        this.yph2VarPer = data.calculation.result.hecDaily?.variancePercentage;
        this.yph2VarMt = data.calculation.result.hecDaily?.variance;

        this.ha2Mt = data.calculation.result.mArea.matureArea;
        this.ha2Budget = data.calculation.result.mArea.budget;
        this.ha2VarMt = data.calculation.result.mArea.variance;
        this.ha2VarPer = data.calculation.result.mArea.variancePercentage;
      }
      if (updateUnitList) {
        this.compoundTreeList(data.operatingUnitList);
      }

      this.spinner.hide();
    }).catch(error => {
      this.spinner.hide();
      //Swal.fire("Error!", error.error, "error");
    });
  }

  getHeader() {
    this.chartOuHeader = [];
    var selList = [];
    var selOuList = this.operatingSelVal;
    this.estateMillList.forEach(c => {
      var regionOU = [];
      c.businessList.forEach(d => {
        d.operatingUnitList.forEach(f => {
          regionOU.push(f.guid);
        });
      });
      var regionFilter = regionOU.filter(g => selOuList.includes(g));
      if (regionFilter.length == regionOU.length) {
        this.chartOuHeader.push({ Sequence: 1, Value: c.description });
        regionFilter.forEach(z => selList.push(z));
        return;
      }
      c.businessList.forEach(h => {
        var busOU = [];
        h.operatingUnitList.forEach(f => {
          busOU.push(f.guid);
        });
        var regionFilter = busOU.filter(g => selOuList.includes(g));
        if (regionFilter.length == busOU.length) {
          this.chartOuHeader.push({ Sequence: 2, Value: h.description });
          regionFilter.forEach(z => selList.push(z));
          return;
        }
        regionFilter.forEach(f => {
          var ouF = h.operatingUnitList.filter(c => c.guid === f)[0];
          if (ouF) {
            this.chartOuHeader.push({ Sequence: 3, Value: ouF.name });
          }
        })
      });
    });
  }
  chartHeaderJoin() {
    this.chartOuHeader = this.chartOuHeader.sort(function (x, y) {
      if (x.Sequence > y.Sequence) {
        return 1;
      }
      if (x.Sequence < y.Sequence) {
        return -1;
      }
      return 0;
    });
    return this.chartOuHeader.map(c => c.Value).join(", ");
  }

  compoundTreeList(data) {
    var ouCount = 0;
    this.operatingUnitList = [];
    this.estateMillList = data.cropMasterRegionList;
    data.cropMasterRegionList.forEach(c => {
      var bu = [];
      c.businessList.forEach(d => {
        var ou = [];
        d.operatingUnitList.forEach(e => {
          ou.push(new TreeviewItem({ text: e.name, value: e.guid }));
          ouCount += 1;
        });
        bu.push(new TreeviewItem({ text: d.name, value: null, children: ou }));
        if(data.cropMasterRegionList.length<=1)
        {
        if(bu.length <=1)
        {
          if(ou.length <=1 )
          {
            this.operatingSelVal.push(data.cropMasterRegionList[0].businessList[0].operatingUnitList[0].guid);
          }
        }
       }
      });
      var region = new TreeviewItem({ text: c.name, value: null, children: bu });
      this.operatingUnitList.push(region);
    });


    this.showSingle = ouCount === 1;
    if (this.showSingle) {
      this.operatingSelSingleVal = data?.cropMasterRegionList[0].businessList[0].operatingUnitList[0].guid;
      this.operatingSelSingleValName = data?.cropMasterRegionList[0].businessList[0].operatingUnitList[0].name;
    }
    
  }

  @ViewChild('dll') dll: ElementRef;
  ngAfterViewInit() {
    this.screenWidth = window.innerWidth;
  }


  async updateOperating(e) {
    this.operatingSelVal = [];
    e.forEach(c => {
      this.operatingSelVal.push(c);
    })
    this.getHeader();
  }
  async filter(){
    if (this.operatingSelVal.length > 0) {
      if(this.compareData == true)
      {
        
        this.compareDate1ValChange = true;
        this.compareDate2ValChange = false;
        await this.getDetails();
        this.compareDate2ValChange = true;
        this.compareDate1ValChange = false;
        await this.getDetails();
      }
      else{
        this.getHeader();
        this.getDetails();
      }
      
    }
  }
  compileCompareObj(obj) {

    if (this.groupingType === "day") {
      obj.entryDate = this.compareDate1ValChange ? this.compareDate1 : this.compareDate2;
    }

    if (this.groupingType === "month") {
      var selYear = this.compareDate1ValChange ? this.compareYearSel1 : this.compareYearSel2;
      var selMonth = this.compareDate1ValChange ? this.compareMonthSel1 : this.compareMonthSel2;
      selYear = selYear || Number(this.datePipe.transform(new Date(), "yyyy"));
      selMonth = selMonth || Number(this.datePipe.transform(new Date(), "MM"));
      obj.month = this.datePipe.transform(new Date(selYear, selMonth - 1, 1), "yyyy-MM-dd");
    }

    if (this.groupingType === 'year') {

      var selYear = this.compareDate1ValChange ? this.compareYearSel1 : this.compareYearSel2;
      selYear = selYear || Number(this.datePipe.transform(new Date(), "yyyy"));
      if(selYear == new Date().getFullYear())
      {
        obj.year = this.datePipe.transform(new Date(selYear, this.selMonth - 1, 1), "yyyy-MM-dd");
      }
      else{
        obj.year = this.datePipe.transform(new Date(selYear, 0, 1), "yyyy-MM-dd");
      }
    }

    if (this.groupingType === 'range') {

      var selYear = this.compareDate1ValChange ? this.compareYearSel1 : this.compareYearSel2;
      var selMonthFrom = this.compareDate1ValChange ? this.compareMonthFromSel1 : this.compareMonthFromSel2;
      var selMonthTo = this.compareDate1ValChange ? this.compareMonthToSel1 : this.compareMonthToSel2;
      selYear = selYear || Number(this.datePipe.transform(new Date(), "yyyy"));
      selMonthFrom = selMonthFrom || Number(this.datePipe.transform(new Date(), "MM"));
      selMonthTo = selMonthTo || Number(this.datePipe.transform(new Date(), "MM"));

      var monthFromDt = this.datePipe.transform(new Date(selYear, selMonthFrom - 1, 1), "yyyy-MM-dd");
      var monthToDt = this.datePipe.transform(new Date(selYear, selMonthTo - 1, 1), "yyyy-MM-dd");
      obj.mthrange = `${monthFromDt};${monthToDt}`;
    }
    if (this.groupingType === 'quarter')
    {
      var selYear = this.compareDate1ValChange ? this.compareYearSel1 : this.compareYearSel2;
      selYear = selYear || Number(this.datePipe.transform(new Date(), "yyyy"));
      var quarterlist = this.compareDate1ValChange ? this.compareQuarter1.split('-') : this.compareQuarter2.split('-');
      this.selMonthFrom = Number(quarterlist[0]);
      this.selMonthTo = Number(quarterlist[1]);
      var monthFromDt = this.datePipe.transform(new Date(selYear, this.selMonthFrom - 1, 1), "yyyy-MM-dd");
      var monthToDt = this.datePipe.transform(new Date(selYear,  this.selMonthTo - 1, 1), "yyyy-MM-dd");
      obj.mthrange = `${monthFromDt};${monthToDt}`;
    }
    return obj;
  }

  openComparison() {
    this.compareDate1 = this.selDate;
    this.compareDate2 = this.selDate;
    this.compareData = true;

    this.compareDate1ValChange = true;
    this.compareDate2ValChange = true;
    this.loadQuaterDropDown();
    this.getDetails();
  }

  closedComparison() {
    this.compareData = false;
    this.compareDate1ValChange = false;
    this.compareDate2ValChange = false;
    this.getDetails();
  }

  filterDay() {
    this.groupingType = "day";
    this.chartDateSel = 0;
    this.compareDate1ValChange = true;
    this.compareDate2ValChange = true;
    this.selDate =this.getYesterday();
    this.getDetails();
  }

  filterMonth() {
    this.groupingType = "month";
    this.chartDateSel = 0;
    this.compareDate1ValChange = true;
    this.compareDate2ValChange = true;

    if (this.selYear < (new Date()).getFullYear()) {
      this.assignMonth("months", 12);
    }
    else {
      this.assignMonth("months", Number(this.datePipe.transform(new Date(), 'MM')));
    }


    this.getDetails();
    this.selMonth = Number(this.datePipe.transform(new Date(), 'MM'));
    var dateLabel = this.dateList[this.chartDateSel];
    this.cartSelLabel = "Days";
  }

  filterYear() {
    this.groupingType = "year";
    this.chartDateSel = 0;
    this.compareDate1ValChange = true;
    this.compareDate2ValChange = true;
    this.getDetails();
    this.chartTitle = `Monthly Crop (mt) Year ${this.selYear}`;
    this.cartSelLabel = "Months";

    this.compareYearSel1 = Number(this.datePipe.transform(new Date(), 'YYYY'));
    this.compareYearSel2 = Number(this.datePipe.transform(new Date(), 'YYYY'));
  }

  selMonthFromChange() {
    var curYear = Number(this.datePipe.transform(new Date(), "YYYY"));
    var fromMonth = Number(this.selMonthFrom);
    var year = Number(this.selYear);
    this.chartDateSel = 0;
    if (year < curYear) {
      this.assignMonth("monthsTo", 12, Number(this.selMonthFrom));
      if (this.selMonthTo < this.selMonthFrom) {
        this.selMonthTo = this.selMonthFrom;
      };
    }
    else {
      if (Number(this.selMonthTo) < fromMonth) {
        this.selMonthTo = fromMonth;
      }
      this.assignMonth("monthsTo", Number(this.datePipe.transform(new Date(), 'MM')), Number(this.selMonthFrom));
    }
    //this.getDetails();
    this.chartTitle = `Monthly Crop (mt) Year ${this.selYear} From ${monthList[this.selMonthFrom - 1].alpha} to ${monthList[this.selMonthTo - 1].alpha}`;
  }

  selMonthFromCompareChange(compare1) {

    this.compareDate1ValChange = false;
    this.compareDate2ValChange = false;
    var curYear = Number(this.datePipe.transform(new Date(), "YYYY"));
    if (compare1) {
      this.compareDate1ValChange = true;
      var fromMonth = Number(this.compareMonthFromSel1);
      var year = Number(this.compareYearSel1);
      if (year < curYear) {
        this.assignMonth("compareMonthsTo1", 12, Number(this.compareMonthFromSel1));
        if (this.compareMonthToSel1 < this.compareMonthFromSel1) {
          this.compareMonthToSel1 = this.compareMonthFromSel1;
        };
      }
      else {
        if (Number(this.compareMonthToSel1) < fromMonth) {
          this.compareMonthToSel1 = fromMonth;
        }
        this.assignMonth("compareMonthsTo1", Number(this.datePipe.transform(new Date(), 'MM')), Number(this.compareMonthFromSel1));
      }
    } else {
      this.compareDate2ValChange = true;
      var fromMonth = Number(this.compareMonthFromSel2);
      var year = Number(this.compareYearSel2);
      if (year < curYear) {
        this.assignMonth("compareMonthsTo2", 12, Number(this.compareMonthFromSel2));
        if (this.compareMonthToSel2 < this.compareMonthFromSel2) {
          this.compareMonthToSel2 = this.compareMonthFromSel2;
        };
      }
      else {
        if (Number(this.compareMonthToSel2) < fromMonth) {
          this.compareMonthToSel2 = fromMonth;
        }
        this.assignMonth("compareMonthsTo2", Number(this.datePipe.transform(new Date(), 'MM')), Number(this.compareMonthFromSel2));
      }
    }
    //this.getDetails();
  }


  selMonthToChange() {
    this.chartDateSel = 0;
    //this.getDetails();
    this.chartTitle = `Monthly Crop (mt) Year ${this.selYear} From ${monthList[this.selMonthFrom - 1].alpha} to ${monthList[this.selMonthTo - 1].alpha}`;
  }

  selYearChange() {
    if (this.groupingType === "month") {
      var year = Number(this.selYear);
      var curYear = Number(this.datePipe.transform(new Date(), "YYYY"));
      if (year < curYear) {
        this.assignMonth("months", 12);
      }
      else {
        this.assignMonth("months", Number(this.datePipe.transform(new Date(), "MM")));
        this.selMonth = Number(this.datePipe.transform(new Date(), "MM"));
      }
    }
    else if (this.groupingType === "range") {
      var year = Number(this.selYear);
      var curYear = Number(this.datePipe.transform(new Date(), "YYYY"));
      if (year < curYear) {
        this.assignMonth("monthsFrom", 12);
        this.selMonthFrom = Number(this.datePipe.transform(new Date(), "MM"));
        this.assignMonth("monthsTo", 12, Number(this.selMonthFrom));
        this.selMonthTo = Number(this.datePipe.transform(new Date(), "MM"));
      }
      else {
        this.assignMonth("monthsFrom", Number(this.datePipe.transform(new Date(), "MM")));
        this.selMonthFrom = Number(this.datePipe.transform(new Date(), "MM"));
        this.assignMonth("monthsTo", Number(this.datePipe.transform(new Date(), 'MM')), Number(this.selMonthFrom));
        this.selMonthTo = Number(this.datePipe.transform(new Date(), "MM"));
      }
    }
    //this.getDetails();
  }

  selYearChangeCom(compare1: boolean = false) {
    var curYear = Number(this.datePipe.transform(new Date(), "YYYY"));
    var MonthCtr = compare1 ? "compareMonths1" : "compareMonths2";
    var MonthFromCtr = compare1 ? "compareMonthsFrom1" : "compareMonthsFrom2";
    var MonthToCtr = compare1 ? "compareMonthsTo1" : "compareMonthsTo2";
    var selYear = compare1 ? this.compareYearSel1 : this.compareYearSel2;
    var selMonth = compare1 ? this.compareMonthSel1 : this.compareMonthSel2;
    var selFromMonth = compare1 ? this.compareMonthFromSel1 : this.compareMonthFromSel1;
    var selFromTo = compare1 ? this.compareMonthToSel1 : this.compareMonthToSel2;
    var year = Number(selYear);

    this.compareDate1ValChange = compare1;
    this.compareDate2ValChange = !compare1;

    if (this.groupingType === "month") {

      if (year < curYear) {
        this.assignMonth(MonthCtr, 12);
      }
      else {
        this.assignMonth(MonthCtr, Number(this.datePipe.transform(new Date(), "MM")));
        selMonth = Number(this.datePipe.transform(new Date(), "MM"));
      }
    }
    else if (this.groupingType === "range") {
      if (year < curYear) {
        this.assignMonth(MonthFromCtr, 12);
        selFromMonth = Number(this.datePipe.transform(new Date(), "MM"));
        this.assignMonth(MonthToCtr, 12, Number(this.selMonthFrom));
        selFromTo = Number(this.datePipe.transform(new Date(), "MM"));
      }
      else {
        this.assignMonth(MonthFromCtr, Number(this.datePipe.transform(new Date(), "MM")));
        selFromMonth = Number(this.datePipe.transform(new Date(), "MM"));
        this.assignMonth(MonthToCtr, Number(this.datePipe.transform(new Date(), 'MM')), Number(this.selMonthFrom));
        selFromTo = Number(this.datePipe.transform(new Date(), "MM"));
      }
    }
    //this.getDetails();
  }

  filterRange() {
    this.groupingType = "range";
    if (this.compareData) {
      this.compareMonthFromSel1 = Number(this.datePipe.transform(new Date(), 'MM'));
      this.compareMonthToSel1 = Number(this.datePipe.transform(new Date(), 'MM'));

      this.compareMonthFromSel2 = Number(this.datePipe.transform(new Date(), 'MM'));
      this.compareMonthToSel2 = Number(this.datePipe.transform(new Date(), 'MM'));

      this.compareYearSel1 = Number(this.datePipe.transform(new Date(), 'YYYY'));
      this.compareYearSel2 = Number(this.datePipe.transform(new Date(), 'YYYY'));

      this.compareDate1ValChange = true;
      this.compareDate2ValChange = true;
      this.getDetails();
    }
    else {
      this.chartDateSel = 0;
      this.selMonthFrom = Number(this.datePipe.transform(new Date(), 'MM'));
      this.selMonthTo = Number(this.datePipe.transform(new Date(), 'MM'));
      if (this.selYear < (new Date()).getFullYear()) {
        this.assignMonth("monthsFrom", 12);
        this.assignMonth("monthsTo", 12, Number(this.selMonthFrom));
      }
      else {
        this.assignMonth("monthsFrom", Number(this.datePipe.transform(new Date(), 'MM')));
        this.assignMonth("monthsTo", Number(this.datePipe.transform(new Date(), 'MM')), Number(this.selMonthFrom));
      }

      this.getDetails();

      var frmMonth = this.datePipe.transform(new Date(), 'MMM');
      var toMonth = this.datePipe.transform(new Date(), 'MMM');
      this.chartTitle = `Monthly Crop (mt) Year ${this.selYear} From ${frmMonth} to ${toMonth}`;
      this.cartSelLabel = "Months";
    }
  }
  filterQuarter() {
    this.groupingType = "quarter";
    if (this.compareData) {
      this.compareMonthFromSel1 = Number(this.datePipe.transform(new Date(), 'MM'));
      this.compareMonthToSel1 = Number(this.datePipe.transform(new Date(), 'MM'));

      this.compareMonthFromSel2 = Number(this.datePipe.transform(new Date(), 'MM'));
      this.compareMonthToSel2 = Number(this.datePipe.transform(new Date(), 'MM'));

      this.compareYearSel1 = Number(this.datePipe.transform(new Date(), 'YYYY'));
      this.compareYearSel2 = Number(this.datePipe.transform(new Date(), 'YYYY'));

      this.compareDate1ValChange = true;
      this.compareDate2ValChange = true;
      this.getDetails();
      this.loadQuaterDropDown();
    }
    else {
      this.chartDateSel = 0;
      this.loadQuaterDropDown();
      var quarterlist = this.selectedQuarter.split('-');
      this.selMonthFrom = Number(quarterlist[0]);
      this.selMonthTo = Number(quarterlist[1]);
      this.getDetails();
      this.loadQuaterDropDown();
      this.chartTitle = `Monthly Crop (mt) Year ${this.selYear} From ${monthList[this.selMonthFrom - 1].alpha} to ${monthList[this.selMonthTo - 1].alpha}`;
      this.cartSelLabel = "Months";
    }
  }
  //kelvin 30/11/2022
  selQuarterChange() {
    var quarterlist = this.selectedQuarter.split('-');
    this.selMonthFrom = Number(quarterlist[0]);
    this.selMonthTo = Number(quarterlist[1]);
    this.chartDateSel = 0;
    //this.getDetails();
    this.chartTitle = `Monthly Crop (mt) Year ${this.selYear} From ${monthList[this.selMonthFrom - 1].alpha} to ${monthList[this.selMonthTo - 1].alpha}`;
  }
  compareDate1Change() {
    this.compareDate1ValChange = true;
    this.compareDate2ValChange = false;
    //this.getDetails();
  }

  compareYearChange(compare1: boolean) {
    if (this.groupingType === "month") {
      var year = Number(compare1 ? this.compareYearSel1 : this.compareYearSel2);
      var curYear = Number(this.datePipe.transform(new Date(), "YYYY"));
      if (year < curYear) {
        this.assignMonth(compare1 ? "compareMonths1" : "compareMonths2", 12);
      }
      else {
        if (compare1) {
          this.assignMonth("compareMonths1", Number(this.datePipe.transform(new Date(), "MM")));
          this.compareMonthSel1 = Number(this.datePipe.transform(new Date(), "MM"));
        } else {
          this.assignMonth("compareMonths2", Number(this.datePipe.transform(new Date(), "MM")));
          this.compareMonthSel2 = Number(this.datePipe.transform(new Date(), "MM"));
        }
      }
    }
    else if (this.groupingType === "range") {
      var curYear = Number(this.datePipe.transform(new Date(), "YYYY"));
      if (compare1) {
        var year = Number(this.compareYearSel1);
        if (year < curYear) {
          this.assignMonth("compareMonthsFrom1", 12);
          this.compareMonthFromSel1 = Number(this.datePipe.transform(new Date(), "MM"));
          this.assignMonth("compareMonthsTo1", 12, Number(this.compareMonthFromSel1));
          this.compareMonthToSel1 = Number(this.datePipe.transform(new Date(), "MM"));
        }
        else {
          this.assignMonth("compareMonthsFrom1", Number(this.datePipe.transform(new Date(), "MM")));
          this.compareMonthFromSel1 = Number(this.datePipe.transform(new Date(), "MM"));
          this.assignMonth("compareMonthsTo1", Number(this.datePipe.transform(new Date(), 'MM')), Number(this.compareMonthFromSel1));
          this.compareMonthToSel1 = Number(this.datePipe.transform(new Date(), "MM"));
        }
      }
      else {
        var year = Number(this.compareYearSel2);
        if (year < curYear) {
          this.assignMonth("compareMonthsFrom2", 12);
          this.compareMonthFromSel2 = Number(this.datePipe.transform(new Date(), "MM"));
          this.assignMonth("compareMonthsTo2", 12, Number(this.compareMonthFromSel1));
          this.compareMonthToSel2 = Number(this.datePipe.transform(new Date(), "MM"));
        }
        else {
          this.assignMonth("compareMonthsFrom2", Number(this.datePipe.transform(new Date(), "MM")));
          this.compareMonthFromSel2 = Number(this.datePipe.transform(new Date(), "MM"));
          this.assignMonth("compareMonthsTo2", Number(this.datePipe.transform(new Date(), 'MM')), Number(this.compareMonthFromSel2));
          this.compareMonthToSel2 = Number(this.datePipe.transform(new Date(), "MM"));
        }
      }
    }
    //this.getDetails();
  }

  compareDate2Change() {
    this.compareDate1ValChange = false;
    this.compareDate2ValChange = true;
   // this.getDetails();
  }


  @ViewChild("columnChart") chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  buildDashboardChart(columns, category) {
    this.compileChartName();
    var dataSeries = columns.map((data) => data.Sum);
    var initialZoomRange = this.getInitialRange(dataSeries);
    c3.generate({
      bindto: '#dashboardChart',
      title: {
        text: 'Crop Data Chart'
      },
      data: {
        columns: [
          dataSeries
        ],
        type: "bar",
      },
      axis: {
        y: {
          label: {
            text: 'Crop Data (mt)',
            position: 'outer-middle'
          }
        },
        x: {
          type: 'category',
          categories: category
        }
      },
      zoom: {
        enabled: true,
        rescale: true,
        initialRange: initialZoomRange ? [initialZoomRange[0], initialZoomRange[1]] : null
      }
    });
  }

  getInitialRange(e) {
    if (this.screenWidth < 600) {
      if (e.length - 1 === 1) { return null }
      else if (this.groupingType === 'quarter') { return [0, 2] }
      return [0, 6];
    } else {
      return null;
    }
  }
  compileChartName() {
    if (this.groupingType === "month") {
      this.chartTitle = `Daily Crop (mt) Day ${monthList[this.selMonth - 1].desc}`;
      this.SubChartLabel = 'Day';
    } else if (this.groupingType === "range"||this.groupingType === "quarter") {
      this.chartTitle = `Monthly Crop (mt) Year ${this.selYear} from ${monthList[this.selMonthFrom - 1].desc} to ${monthList[this.selMonthTo - 1].desc}`;
      this.SubChartLabel = 'Month';
    }
    else {
      this.chartTitle = `Monthly Crop (mt) Year ${this.selYear}`;
      this.SubChartLabel = 'Month';
    }
  }

  compilePieChartName() {
      this.chartTitle = `Crop Entry Status ${[this.getYesterday()]}`;
  }

  buildColumnChart(data) {

    data = data || this.chartData;
    this.chartData = data;
    if (!data.calculation.result?.grpLineChart) { return; }
    var seriesX: any[];
    var category = data.calculation.result.grpLineChart.filter(c => c.items.length > 0).map((c) => c.header);
    if (!category) { return; };
    this.compileDateList(category);

    var dataList = data.calculation.result.grpLineChart.map((e) => e.items);
    seriesX = this.compileC3ColumnData(dataList, category);

    this.buildDashboardChart(seriesX, category);
  }
  
  buildDashboardPieChart(columns, category) {
    try{
      this.compilePieChartName;
      var dataSeries = columns.map((data) => data);
      var initialZoomRange = this.getInitialRange(dataSeries);
      c3.generate({
        bindto: '#dashboardPieChart',
        data: {
          columns: [
          ['Submit', dataSeries[0]],
          ['Draft', dataSeries[1]],
          ['Not-Submitted', dataSeries[2]]  
          ],
          type: "pie",
          colors: { 
            'Submit': '#87AB69',
            'Draft': '#FFA500',
            'Not-Submitted': '#FF0000'
          },
        },
        zoom: {
          enabled: true,
          rescale: true,
          initialRange: initialZoomRange ? [initialZoomRange[0], initialZoomRange[1]] : null
        }
      });
    }
    catch(e: unknown){
      console.log(e);
    }
  
  }

  buildDashboardBarLineChart(dataList, category, productivityList) {
    var dataSeries = dataList.map((data) => data);
    var productivitySeries = productivityList.map((data)=> data);

     productivitySeries.unshift("Productivity");
     dataSeries.unshift("Rainfall");

    var initialZoomRange = this.getInitialRange(dataSeries);
    c3.generate({
      bindto: '#dashboardBarLineChartrainfall',
      title: {
        text: 'Productivity / Rainfall Chart'
      },
      data: {
        columns: [
          dataSeries,
          productivitySeries,
        ],
        type: 'bar',
        types: {
          Productivity: 'spline',
          Rainfall: 'bar'
        }
      },
      axis: {
        y: {
          label: {
            text: 'Rainfall (mm) / Productivity (mt)',
            position: 'outer-middle'
          }
        },
        x: {
          type: 'category',
          categories: category
        }
      },
      zoom: {
        enabled: true,
        rescale: true,
        initialRange: initialZoomRange ? [initialZoomRange[0], initialZoomRange[1]] : null
      }
    });
  }

  buildDashboardBarLineHarvesterChart(harvesterTotal, category,taskHarvesterTotal,taskTotal) {
    var harvesterTotalSeries = harvesterTotal.map((data) => data);
    var taskHarvesterTotal = taskHarvesterTotal.map((data)=> data);
    var taskTotal = taskTotal.map((data)=> data);


    taskHarvesterTotal.unshift("Task Harvester Total");
    harvesterTotalSeries.unshift("Harvester Total");
    taskTotal.unshift("Task Total");

    var initialZoomRange = this.getInitialRange(harvesterTotalSeries);
    c3.generate({
      bindto: '#dashboardBarLineChartHarvester',
      title: {
        text: 'Harvester / Task Total Chart'
      },
      data: {
        columns: [
          harvesterTotalSeries,
          taskTotal,
          taskHarvesterTotal
        ],
        type: 'bar',
        types: {
          "Task Total": 'spline',
          "Harvester Total": 'bar',
          "Task Harvester Total": 'bar',
        }
      },
      axis: {
        y: {
          label: {
            text: 'Task Total',
            position: 'outer-middle'
          }
        },
        x: {
          type: 'category',
          categories: category
        }
      },
      zoom: {
        enabled: true,
        rescale: true,
        initialRange: initialZoomRange ? [initialZoomRange[0], initialZoomRange[1]] : null
      }
    });
  }

  buildPieChart(data) {

    data = data || this.chartData;
    this.chartData = data;
    if (!data.calculation.result?.estateEntryChart) { return; }
    var seriesX: any[];
    var category = data.calculation.result.estateEntryChart.map(c => c.name);
    if (!category) { return; };

    this.estateProducitivtyPieChartData =[];
    this.estateProducitivtyPieChartData = data.calculation.result?.estateEntryChart;

    var dataList = data.calculation.result.estateEntryChart.map((e) => e.total);

    this.buildDashboardPieChart(dataList, category);
  }

  buildBarLineChart(data) {

    data = data || this.chartData;
    this.chartData = data;
    if (!data.calculation.result?.estateProductivityRainFallChart) { return; }
    var seriesX: any[];
    var category = data.calculation.result.estateProductivityRainFallChart.filter(c => c.items.length > 0).map((c) => c.header);
    if (!category) { return; };

    var dataList = data.calculation.result.estateProductivityRainFallChart.map((c) => c.rainFallTotal);
    var productivityList = data.calculation.result.estateProductivityRainFallChart.map((c) => c.productivityTotal)
    this.estateProductivityRainFallChartData =[];
    this.estateProductivityRainFallChartData = data.calculation.result?.estateProductivityRainFallChart;
    this.buildDashboardBarLineChart(dataList, category,productivityList);
  }

  // phase 2 chart
  buildBarCropEstateChart(data) {

    data = data || this.chartData;
    this.chartData = data;
    if (!data.calculation.result?.cropChart) { return; }
    var seriesX: any[];
    var category = data.calculation.result.cropChart.filter(c => c.items.length > 0).map((c) => c.header);
    if (!category) { return; };

    var cropActualTotal = data.calculation.result.cropChart.map((c) => c.cropActualTotal);
    var cropBudgetTotal = data.calculation.result.cropChart.map((c) => c.cropBudgetTotal);
    
    this.cropChartData = [];
    this.cropChartData = data.calculation.result?.cropChart;
    this.buildDashboardBarCropChart(cropActualTotal, category,cropBudgetTotal);
  }
  buildDashboardBarCropChart(cropActualTotal, category,cropBudgetTotal) {
    var cropActualTotal = cropActualTotal.map((data) => data);
    var cropBudgetTotal = cropBudgetTotal.map((data)=> data);
    


    cropActualTotal.unshift("Crop Data Actual");
    cropBudgetTotal.unshift("Crop Data Budget");

    var initialZoomRange = this.getInitialRange(cropActualTotal);
    c3.generate({
      bindto: '#dashboardBarCropActualvsBudget',
      title: {
        text: 'Crop Data Actual / Crop Data Budget Chart'
      },
      data: {
        columns: [
          cropActualTotal,
          cropBudgetTotal
        ],
        type: 'bar',
        types: {
          "Harvester Total": 'bar',
          "Task Harvester Total": 'bar',
        }
      },
      axis: {
        y: {
          label: {
            text: 'Crop Data',
            position: 'outer-middle'
          }
        },
        x: {
          type: 'category',
          categories: category
        }
      },
      zoom: {
        enabled: true,
        rescale: true,
        initialRange: initialZoomRange ? [initialZoomRange[0], initialZoomRange[1]] : null
      }
    });
  }
  buildBarLineHarvesterChart(data) {

    data = data || this.chartData;
    this.chartData = data;
    if (!data.calculation.result?.estateHarversterChart) { return; }
    var seriesX: any[];
    var category = data.calculation.result.estateHarversterChart.filter(c => c.items.length > 0).map((c) => c.header);
    if (!category) { return; };

    var harvesterTotal = data.calculation.result.estateHarversterChart.map((c) => c.harversterTotal);
    var taskHarvesterTotal = data.calculation.result.estateHarversterChart.map((c) => c.taskHarversterTotal);
    var taskTotal = data.calculation.result.estateHarversterChart.map((c) => c.taskTotal);
    this.estateHarversterChartData = [];
    this.estateHarversterChartData = data.calculation.result?.estateHarversterChart;
    this.buildDashboardBarLineHarvesterChart(harvesterTotal, category,taskHarvesterTotal,taskTotal);
  }

  compileColumnData(dataList) {
    var seriesX = [];
    dataList.forEach(c => {
      c.forEach(d => {
        var ex = seriesX.filter((f) => f.name === d.title)[0];
        if (ex) {
          ex["sum"] += Number(d.value);
          ex["data"].push(d.value);
        } else {
          seriesX.push({ "name": d.title, sum: Number(d.value), data: [d.value] })
        }
      })
    });
    return seriesX.filter((f) => f.sum > 0);
  }

  compileC3ColumnData(dataList, category) {
    var seriesX = [];
    var seriesD = [];
    this.chartDetailsData = [];
    var i = 0;

    dataList.forEach(c => {
      const sum = Number(c.reduce((sum, c) => sum + Number(c.value), 0)).toFixed(2);
      seriesX.push({ "Sum": sum, "Sequence": i });

      c.forEach(d => {
        var ex = seriesD.filter((f) => f.name === d.title)[0];
        if (ex) {
          ex["sum"] += Number(d.value);
          ex["data"].push({ "sum": d.value, "label": category[i] });
        } else {
          seriesD.push({ "name": d.title, sum: Number(d.value), data: [{ "sum": d.value, "label": category[i] }] })
        }
      });

      i++;

    });
    var dataRes = [{ "Sum": "Crop Data", "Sequence": i }];
    if (this.groupingType === "range"||this.groupingType === "quarter") {
      seriesX.filter((f) => f.Sum > 0).forEach(c => {
        dataRes.push(c);
      });

      seriesD.forEach(c => {
        var ee = 0;
        c.data.forEach(ef => {
          ef.label = category[ee];
          ee++;
        })
      })
    } else {
      seriesX.forEach(c => {
        dataRes.push(c);
      })
    }

    this.chartDetailsData = seriesD;
    return dataRes;
  }

  compileC3PieChartData(dataList, category) {
    var seriesX = [];
    var seriesD = [];
    this.chartDetailsData = [];
    var i = 0;

    dataList.forEach(c => {
      const total = Number(c.reduce((total, c) => total + Number(c.total), 0));
      seriesX.push({ "Total": total, "Sequence": i });

      c.forEach(d => {
        var ex = seriesD.filter((f) => f.name === d.name)[0];
        if (ex) {
          ex["total"] += Number(d.total);
          ex["data"].push({ "total": d.total, "label": category[i] });
        } else {
          seriesD.push({ "name": d.name, total: Number(d.total), data: [{ "total": d.total, "label": category[i] }] })
        }
      });

      i++;

    });
    var dataRes = [{ "Total": "", "Sequence": i }];
    if (this.groupingType === "range") {
      seriesX.filter((f) => f.Sum > 0).forEach(c => {
        dataRes.push(c);
      });

      seriesD.forEach(c => {
        var ee = 0;
        c.data.forEach(ef => {
          ef.label = category[ee];
          ee++;
        })
      })
    } else {
      seriesX.forEach(c => {
        dataRes.push(c);
      })
    }

    this.chartDetailsData = seriesD;
    return dataRes;
  }

  weekSelectChange() {
    this.buildColumnChart(null);
    this.buildPieChart(null);
    this.buildPieChart(null);
    this.buildBarLineChart(null);
    this.buildBarLineHarvesterChart(null);
  }

  compileDateList(data) {
    var dividerVal = 6;
    if (this.groupingType === "month") {
      dividerVal = 7;
    }
    var list = Math.ceil(data.length / dividerVal);
    this.dateList = [];
    for (var i = 0; i < list; i++) {
      var str = i * dividerVal + 1;
      var end = i * dividerVal + dividerVal;
      if (end > data.length) {
        end = data.length;
      }
      if (this.groupingType === "month") {
        this.dateList.push({ "index": i, "dateV": `${str} to ${end}`, "from": str, "to": end });
      }
      else {
        var fromM ="Jan";
        var toM ="Mar";
        //var fromM = monthList.filter(c => c.alpha.toLocaleLowerCase() === data[str - 1].toLocaleLowerCase())[0].alpha;
        //var toM = monthList.filter(c => c.alpha.toLocaleLowerCase() === data[end - 1].toLocaleLowerCase())[0].alpha;
        this.dateList.push({ "index": i, "dateV": `${fromM} to ${toM}`, "from": str, "to": end });
      }
    }

  }

  compileChartData(dataList) {
    this.chartDetailsData = [];
    var seriesX = [];
    dataList.forEach(c => {
      c.forEach(d => {
        var ex = seriesX.filter((f) => f.name === d.title)[0];
        if (ex) {
          ex["sum"] += Number(d.value);
          ex["data"].push(d.value);
        } else {
          seriesX.push({ "name": d.title, sum: Number(d.value), data: [d.value] })
        }
      })
    });
    this.chartDetailsData = seriesX;
  }

  pageSizeChange(e) {
    this.chartDetails();
  }

  pageChange(e) {
    this.chartDetails();
  }

  chartDetails() {
    this.pageSize = this.pageSize || 10;
    this.startIndex = ((this.pageSize * this.page) - this.pageSize) + 1;
    this.totalRecords = this.chartDetailsData.length;
    this.endIndex = this.page * this.pageSize;
    this.chardDetailsDataList = this.chartDetailsData.slice(this.startIndex - 1, this.endIndex);
  }

  chartDetailsDetails(i) {
    this.showChartDetailsDetails[i] = !this.showChartDetailsDetails[i];
  }

  loadQuaterDropDown() {
    this.apiService.get(`${this.appSettings.apiPath.crop}/api/dashboard/getDashboardQuaterDdl`).then((data: any) => {
      this.QuaterList = data;
      this.selectedQuarter = data[0].value;
      this.compareQuarter1 = data[0].value;
      this.compareQuarter2 = data[0].value;
    }).catch(error => {
    })
  }

}


let monthList = [
  { "month": 1, "desc": "January", "alpha": "Jan" },
  { "month": 2, "desc": "February", "alpha": "Feb" },
  { "month": 3, "desc": "March", "alpha": "Mar" },
  { "month": 4, "desc": "April", "alpha": "Apr" },
  { "month": 5, "desc": "May", "alpha": "May" },
  { "month": 6, "desc": "June", "alpha": "Jun" },
  { "month": 7, "desc": "July", "alpha": "Jul" },
  { "month": 8, "desc": "August", "alpha": "Aug" },
  { "month": 9, "desc": "September", "alpha": "Sep" },
  { "month": 10, "desc": "October", "alpha": "Oct" },
  { "month": 11, "desc": "November", "alpha": "Nov" },
  { "month": 12, "desc": "December", "alpha": "Dec" }
]
